import Vue from 'vue';

Vue.directive('download', {
  bind: (el, binding) => {
    console.log(el);
    console.log(binding);
  },
});
